import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { CaretLeftIcon } from '@phosphor-icons/react';
import { useQuery } from '@tanstack/react-query';
import { getUsers } from 'api/users';
import LoadingOverlay from 'components/LoadingOverlay';
import Button from 'components/Button';

export default function Users() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const [searchUsers, setSearchUsers] = useState('');

    const { data: users, isLoading } = useQuery({
        queryKey: ['users'],
        queryFn: async () => await getUsers({}),
    });

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <LoadingOverlay isLoading={isLoading} />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container>
                    <div className='flex gap-3 items-center pb-8 pt-20 md:pt-14'>
                        <div className='flex-1 flex items-center gap-3'>
                            <Link to="/settings" className=''>
                                <CaretLeftIcon size={26} className='hover:text-muted' />
                            </Link>
                            <p className='text-3xl'>Utenti</p>
                        </div>
                        <Button
                            component={Link}
                            to="/settings/users/create"
                        >Crea nuovo utente</Button>
                    </div>

                    <div className=''>
                        <div className='w-full'>
                            <form>
                                <input  
                                    type="text"
                                    placeholder='Cerca...'
                                    className='w-full border border-light text-sm rounded-sm focus:ring-0 focus:outline-none focus:border-grey placeholder:text-muted px-4 py-3 max-w-[400px] block'
                                    onChange={(e) => setSearchUsers(e.target.value)}
                                />
                            </form>
                        </div>

                        <div className='border border-light rounded-sm mt-6'>
                            {users?.filter(user => {
                                return user.firstname?.toLowerCase().includes(searchUsers.toLowerCase()) || user.lastname?.toLowerCase().includes(searchUsers.toLowerCase());
                            }).map((user, index) => {
                                return (
                                    <Link to={`/settings/users/${user._id}`} key={index} className='border-b border-light last:border-0 hover:bg-verylight flex items-center gap-4 p-4'>
                                        <div className='flex-1'>
                                            <p className='font-semibold'>{user.firstname} {user.lastname}</p>
                                        </div>
                                        <div className='flex-1'>
                                            <p className='text-muted'>{user.offices?.join(', ')}</p>
                                        </div>

                                        <div className='flex-1 flex gap-2 justify-end items-center'>
                                            <div className=''>
                                                {user?.superadmin && (
                                                    <span className='block text-lime-500 uppercase text-xs font-medium'>Superadmin</span>
                                                )}
                                            </div>

                                        </div>
                                    </Link>
                                )
                            })}
                        </div>
                    </div>
                </Container>
            </div>
        </>
    )
}
